/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { sanitizeUrl } from '../../UIKit1/markup';
function LinkInner(props) {
  var forgeDoc = props.forgeDoc,
    render = props.render;
  var _ref = forgeDoc.props,
    href = _ref.href,
    openNewTab = _ref.openNewTab;
  return jsx("a", {
    target: openNewTab ? '_blank' : undefined,
    href: sanitizeUrl(href),
    rel: "noopener noreferrer"
  }, forgeDoc.children.map(render));
}
export var Link = function Link(props) {
  return jsx(LinkInner, props);
};